import type { SVGProps } from "react";

export default function MenuIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 374.14 373.6"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<g>
				{/* Black parts - use currentColor so they can be controlled via CSS */}
				<path
					fill="currentColor"
					d="M214.35,213.83c1.36-1.36,5.15-2.32,7.17-2.33l147.6.5c2.08.81,3.68,2.42,4.5,4.5v152.1c-.81,2.08-2.42,3.68-4.5,4.5l-148.6.5c-7.25-.08-8.03-4.52-8.49-10.51-3.54-45.71,2.78-95.9-.01-142.09.02-2.01.98-5.81,2.33-7.17ZM358.07,228.55h-129v129h127.5c.11,0,1.5-1.39,1.5-1.5v-127.5Z"
				/>
				{/* Green parts - keep fixed color */}
				<path fill="#3fdfcf" d="M214.35,159.27c-1.36-1.36-2.32-5.15-2.33-7.17l.5-147.6c.82-2.08,2.42-3.69,4.5-4.5h152.1c2.08.82,3.69,2.42,4.5,4.5l.49,148.6c.42,5.72-4.48,8.31-9.5,8.5-46.08-3.23-97.68,4.12-143.1,0-2.11-.19-5.69-.86-7.17-2.33ZM358.07,144.55V17.05c0-.11-1.39-1.5-1.5-1.5h-127.5v129h129Z" />
				<g>
					<path fill="#3fdfcf" d="M159.79,213.83c1.36,1.36,2.32,5.15,2.33,7.17-2.79,46.19,3.53,96.38-.01,142.09-.46,5.99-1.25,10.42-8.49,10.51l-148.6-.5c-2.08-.81-3.68-2.42-4.5-4.5v-152.1c.81-2.08,2.42-3.68,4.5-4.5l147.6-.5c2.01.02,5.81.98,7.17,2.33ZM145.07,228.55H16.07v127.5c0,.11,1.39,1.5,1.5,1.5h127.5v-129Z" />
					<path fill="currentColor" d="M159.79,159.27c-1.48,1.48-5.05,2.14-7.17,2.33-45.43,4.12-97.02-3.24-143.1,0-5.02-.2-9.92-2.79-9.5-8.5L.52,4.5C1.33,2.42,2.94.82,5.02,0h152.1c2.08.81,3.68,2.42,4.5,4.5l.5,147.6c-.02,2.01-.98,5.81-2.33,7.17ZM145.07,15.55H17.57c-.11,0-1.5,1.39-1.5,1.5v127.5h129V15.55Z" />
				</g>
			</g>
		</svg>
	);
}

